import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

class TTTargetInput extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      value: this.props.targetInput.translValue
    };
  }

  handleTextFieldChange = (ev, value) => this.setState({ value });

  handleTextFieldBlur = ev => this.props.ttActions.updateTargetInputFieldData(this.props.targetInput.id, ev.target.value);

  render() {
    const { disabled } = this.props;
    return (
      <div>
        <TextField
          hintText="Sovos Data Value"
          value={ this.state.value }
          style={ { marginTop: -20 } }
          hintStyle={ { fontSize: 13 } }
          inputStyle={ { fontSize: 13 } }
          underlineStyle={ { borderColor: '#999' } }
          onChange={ this.handleTextFieldChange }
          onBlur={ this.handleTextFieldBlur }
          fullWidth={ true }
          disabled={ disabled }
        />
      </div>
    );
  }
}

TTTargetInput.propTypes = {
  targetColumn: PropTypes.object.isRequired,
  targetInput: PropTypes.object.isRequired,
  ttActions: PropTypes.shape({
    updateTargetInputFieldData: PropTypes.func
  }).isRequired,
  disabled: PropTypes.bool
};

TTTargetInput.defaultProps = {
  disabled: false
};

export default TTTargetInput;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/c/ttMainGrid/c/ttTargetInput/TTTargetInput.js